import { Component, OnInit, AfterViewInit, Input, EventEmitter, Output } from '@angular/core';
import { Question } from '../../Models/dennysFlow';
import { DisplayLanguage } from '../../Models/DisplayLanguage';

@Component({
  selector: 'app-buttons-input',
  templateUrl: './buttons-input.component.html',
  styleUrls: ['./buttons-input.component.less']
})
export class ButtonsInputComponent implements OnInit {

  @Input() model : Question;
  @Input() for : string;
  @Input() text : string;
  @Input() type : string;
  @Input() monthRange : string;
  @Output() updated = new EventEmitter<string>();
  @Input() weekRange : string;
  @Input() language : DisplayLanguage;

  range1Text : string;
  range2Text : string;
  range3Text : string;

  constructor(){}
  
  setInputRange(i : number) : void {
    this.model.Answer = i;
    this.model.Set(i);
    console.log(this.model.Answer);
    this.updated.emit('updated');
    document.getElementById(`${this.for}${i}`).classList.add('glowing');
  }

  public selected(comparer : number) : boolean {
    return this.model.Get() == comparer;
  }

  ngOnInit() {
    let weekLabel : string;
    let monthLabel : string;
    if(this.language == 0) {
      weekLabel = 'weeks';
      monthLabel = 'months';
    }
    if(this.language == 1) {
      weekLabel = 'semanas';
      monthLabel = 'meses';
    }
    if(this.monthRange) {
      let val1 = +this.monthRange / 3;
      let val2 = +this.monthRange / 3 + +this.monthRange / 3;
      this.range1Text = `0 - ${val1} ${monthLabel}`;
      this.range2Text = `${val1+1} - ${val2} ${monthLabel}`;
      this.range3Text = `${val2+1} - ${this.monthRange} ${monthLabel}`;
    }
    if(this.weekRange) {
      let val1 = Math.trunc((+this.weekRange / 3));
      let val2 = Math.trunc((+this.weekRange / 3 + +this.weekRange / 3));
      this.range1Text = `0 - ${val1} ${weekLabel}`;
      this.range2Text = `${val1+1} - ${val2} ${weekLabel}`;
      this.range3Text = `${val2+1} - ${this.weekRange} ${weekLabel}`;
    }
  }

}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/utility-components/buttons-input/buttons-input.component.ts